import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import appRoutes from "../../routes/appRoutes";
import { setForumReadComments, setForumReadTopics } from "../../reduxStore/actions/commonAction";
import Label from "../../components/label";
import ICDateInput from "../../components/form/dateInput";
import ViewForumList from "../../containers/Forum/viewForumList";
import MakeAPICall from "../../apiCalls/common";
import ICIconBtn from "../../components/iconButton";
import ICCheckbox from "../../components/form/checkbox";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import { markAllPostsReadApiRoute } from "../../apiRoutes";

class ForumListPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiCall: "",
      apiCall1: "",
      startDate: null,
      endDate: null,
      filterByDateCall: false,
      filterActive: true,
      myPostsCheckbox: false,
      textSearch: "",
      doTextSearch: false
    };

    this.colInputInterval = createRef();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentAPICall = data => {
    this.setState({ apiCall: data });
  };

  createForumPost = () => {
    this.props.history.push(appRoutes.createForumPost);
  };

  filterByDate = () => {
    this.setState({
      filterByDateCall: !this.state.filterByDateCall,
      filterActive: false
    });
  };

  markAllRead = () => {
    this.setState({
      apiCall1: {
        reqType: "POST",
        reqURL: markAllPostsReadApiRoute,
        successCallback: async res => {
          this.props.setForumReadTopics(0);
          this.props.setForumReadComments(0);
          this.setState({
            apiCall: {
              ...this.state.apiCall
            }
          });
        },
        failureCallback: console.error
      }
    });
  };

  cancelFilterByDate = () => {
    let dataObj = {
      filterActive: true,
      startDate: null,
      endDate: null
    };
    this.setState({
      filterActive: dataObj.filterActive,
      startDate: dataObj.startDate,
      endDate: dataObj.endDate,
      filterByDateCall: !this.state.filterByDateCall,
      myPostsCheckbox: false
    });
  };

  applyTodayDateFilter = event => {
    this.setState({
      myPostsCheckbox: event.target.checked
    });
  };

  handleInputChange = val => {
    // here this timeout logic is applied to tackle user input stopped so that we only call function when the user have stopped typing
    clearTimeout(this.colInputInterval.current);
    this.setState({
      textSearch: val
    });

    this.colInputInterval.current = setTimeout(() => {
      this.setState({
        doTextSearch: val.trim().length === 0 ? false : true
      });
    }, 1000);
  };

  render() {
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;

    return (
      <div className="row rounded p-3 consult-history-page">
        {/* Top Filters */}
        <div className="col-sm-6 pt-3 pl-3">
          <Label title="Forum" className="big" />
        </div>
        <div className="col-md-6 text-right pt-3">
          <Button
            clickEvent={this.markAllRead}
            title="Mark All Read"
          />
          <Button
            className="ml-2 ic-btn-transparent-navy-blue"
            title="Post New Topic"
            clickEvent={this.createForumPost}
          />
        </div>
        <div className="row col-md-12 pl-3 pt-2 pr-0 pb-3 d-flex flex-row flex-wrap">
          <div className="d-flex flex-row w-100">
            <div
              style={{ width: "155px", marginTop: "-10px" }}
              className="mr-3"
            >
              <ICDateInput
                id="startdate"
                className="cal-primary-bg"
                label="Start Date"
                defaultDate={this.state.startDate}
                handleChange={date =>
                  this.setState({ startDate: date, filterActive: true })
                }
                filterOn={this.state.startDate}
              />
            </div>
            <div
              style={{ width: "155px", marginTop: "-10px" }}
              className="pr-0 text-right mr-3"
            >
              <ICDateInput
                id="endDate"
                className="cal-primary-bg"
                label="End Date"
                defaultDate={this.state.endDate}
                handleChange={date =>
                  this.setState({ endDate: date, filterActive: true })
                }
                filterOn={this.state.endDate}
              />
            </div>
            <div className="mr-4">
              <ICIconBtn
                title=""
                className={
                  this.state.filterActive ? "font-15 only-icon" : "d-none"
                }
                type="button"
                clickEvent={this.filterByDate}
                icon="fas fa-arrow-right"
              />

              <ICIconBtn
                title=""
                className={
                  !this.state.filterActive
                    ? "font-15 only-icon danger"
                    : "d-none"
                }
                type="button"
                clickEvent={this.cancelFilterByDate}
                icon="fas fa-times"
              />
            </div>
            <div className="mr-4 d-flex flex-row align-items-center">
              <Label className="m-0 p-0 ml-2" title="My Posts" />
              <div className="ic-checkbox-container ml-2">
                <ICCheckbox
                  name="myPostsCheckbox"
                  onChange={this.applyTodayDateFilter}
                  value={this.state.myPostsCheckbox}
                />
              </div>
            </div>
            <div className="flex-grow-1 d-flex flex-row align-items-center">
              <p style={{ minWidth: "fit-content" }} className="mb-0">
                Search all posts:
              </p>
              <ICInput
                name="searchColumnsInput"
                className="ml-2 search-columns-input"
                type="text"
                value={this.state.textSearch}
                onChange={e => this.handleInputChange(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="col-sm-12 border-bottom"></div>

        <div className="col-sm-12 mt-4">
          <ViewForumList
            makeAPICall={this.componentAPICall}
            startDate={startDate}
            endDate={endDate}
            filterByDateCall={this.state.filterByDateCall}
            user={this.props.user}
            myPostsCheckbox={this.state.myPostsCheckbox}
            textSearch={this.state.textSearch}
            doTextSearch={this.state.doTextSearch}
          />
        </div>

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
        <MakeAPICall apiParam={this.state.apiCall1} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  commonReducer: state.commonReducers
});

const mapDispatchToProps = dispatch => ({
  setForumReadTopics: data => dispatch(setForumReadTopics(data)),
  setForumReadComments: data => dispatch(setForumReadComments(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ForumListPage);
